export enum AssetInfoCollapsedState {
    Collapsed = 1,
    PartialRight = 3,
    Open = 2,
    PartialLeft = 4,
}
